import React from 'react';
import { Link } from 'react-router-dom';
export default function AnnouncementBar() {
  const announcements = [{
    text: "In-Person Therapy in Redwood City & Online Across California",
    link: "/services/individual-sessions"
  }, {
    text: "The Compassionate Connect Method™ Group Coaching — Enrolling Now",
    link: "/services/group-coaching"
  }];
  return <div className="w-full bg-sage-600 fixed top-0 left-0 right-0 z-50" data-name="Announcement Bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2 md:gap-4">
          {announcements.map((announcement, index) => <Link key={index} to={announcement.link} className="text-center text-white text-xs md:text-sm font-medium hover:text-sage-100 transition-colors duration-300 flex-1" data-tracking-id={`link-announcement-${index}`}>
              {announcement.text}
            </Link>)}
        </div>
      </div>
    </div>;
}